module.exports = __webpack_public_path__ + "img/hb5.172dfe8a.jpg";